/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/



//table columns for QA Review and Approval history table
export const columnsHistory: TableColumn[] = [
   
        {
        Header: "tableCommon.sl_no",
        accessor: "slno",
    },
    {
        Header: 'scheduleOperator.tableColumns.production_schedule',
        accessor: 'production_schedule',
    },
    {
        Header: 'scheduleOperator.tableColumns.product_name',
        accessor: 'product_name',
    },
    
    // {
    //     Header: "scheduleProduction.tableColumns.area_name",
    //     accessor: "area_name",
    // },
    {
        Header: "Production Start & End Date",
        accessor: "StartAndEnd",
    },
    {
        Header: "Status",
        accessor: "status",
    }
];


//columns for QA Review and Approval columns
export const columnsNew: TableColumn[] = [
         {
        Header: "tableCommon.sl_no",
        accessor: "slno",
    },
    {
        Header: 'scheduleOperator.tableColumns.production_schedule',
        accessor: 'production_schedule',
    },
    {
        Header: 'scheduleOperator.tableColumns.product_name',
        accessor: 'product_name',
    },
    
    // {
    //     Header: "scheduleProduction.tableColumns.area_name",
    //     accessor: "area_name",
    // },
    {
        Header: "Production Start & End Date",
        accessor: "StartAndEnd",
    },
    {
        Header: "Status",
        accessor: "status",
    }
];

  
  interface TableColumn {
    Header: string;
    accessor: string;
  }